/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ floor: NonNullable<unknown> }} Plan_Edit_Volume_FloorInputs */

const en_us2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`below the minimum effective dose (~${i?.floor})`)
};

const pt_br2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`abaixo do mínimo eficaz (~${i?.floor})`)
};

const es_419_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`por debajo de la dosis mínima eficaz (~${i?.floor})`)
};

const pt_pt2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`abaixo do mínimo eficaz (~${i?.floor})`)
};

const fr_fr2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sous la dose minimale efficace (~${i?.floor})`)
};

const de_de2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`unter der minimalen wirksamen Dosis (~${i?.floor})`)
};

const it_it2_plan_edit_volume_floor = /** @type {(inputs: Plan_Edit_Volume_FloorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sotto la dose minima efficace (~${i?.floor})`)
};

/**
* | output |
* | --- |
* | "below the minimum effective dose (~{floor})" |
*
* @param {Plan_Edit_Volume_FloorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_volume_floor = /** @type {((inputs: Plan_Edit_Volume_FloorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Volume_FloorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_volume_floor(inputs)
	if (locale === "es-419") return es_419_plan_edit_volume_floor(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_volume_floor(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_volume_floor(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_volume_floor(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_volume_floor(inputs)
	return en_us2_plan_edit_volume_floor(inputs)
});
export { plan_edit_volume_floor as "plan-edit.volume_floor" }